import { render, staticRenderFns } from "./TransportFeeSubList.vue?vue&type=template&id=46255408&scoped=true"
import script from "./TransportFeeSubList.vue?vue&type=script&lang=js"
export * from "./TransportFeeSubList.vue?vue&type=script&lang=js"
import style0 from "./TransportFeeSubList.vue?vue&type=style&index=0&id=46255408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46255408",
  null
  
)

export default component.exports